// removed by extract-text-webpack-plugin
module.exports = {"Price":"Price__Price___2gcSD","PriceText":"Price__PriceText___sWoZm","PriceWhite":"Price__PriceWhite___74PHd"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/Price/Price.less
// module id = 1198
// module chunks = 0 1